module.exports = __webpack_public_path__ + "fonts/DINPro-CondLightIta.b22bc4c2.otf";